/**
 * レスポンスがActiveModelErrorMessageの規定のエラーメッセージである場合に取り出す。
 * この関数では入力内容の形式チェックは行っていないことに注意。
 */
export async function getActiveModelErrorMessage(
  res: Response,
  defaultMsg = "エラーが発生しました。画面をリロードしてもう一度試してください。"
): Promise<string> {
  // e.g. {"messages":{"foo":["fooは不正な値です"]}}
  const resBody: { messages?: Record<string, string[]> } = await res
    .json()
    .catch(() => null);
  const msg = Object.values(resBody?.messages || {})
    .flat()
    .join("\n")
    .trim();
  return msg || defaultMsg;
}
